// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-cell {
  width: 150px;
  text-align: center;
  padding: 8px;
}

.organization-logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border-radius: 5px;
  display: block;
  margin: 0 auto;
}

.disabled-row {
  background-color: #f5f5f5;
  color: #a0a0a0;
  pointer-events: none;
  opacity: 0.6;
}

.headerTest {
  background-color: #F8F9FA;
  height: 5rem;
}

.header-border {
  border-top: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
}

.table-line {
  border-bottom: 1px solid #ccc !important;
}
.table-line p {
  margin-bottom: 0;
  font-weight: 500;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/change-organization-modal/change-organization-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,kBAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AACJ;;AAEA;EACI,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,qCAAA;EACA,wCAAA;AACJ;;AAEA;EACI,wCAAA;AACJ;AACI;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;AACR","sourcesContent":[".image-cell {\n    width: 150px;\n    text-align: center;\n    padding: 8px;\n}\n\n.organization-logo {\n    width: 80px;\n    height: 80px;\n    object-fit: contain;\n    border-radius: 5px;\n    display: block;\n    margin: 0 auto;\n}\n\n.disabled-row {\n    background-color: #f5f5f5;\n    color: #a0a0a0;\n    pointer-events: none;\n    opacity: 0.6;\n}\n\n.headerTest {\n    background-color: #F8F9FA;\n    height: 5rem;\n}\n\n.header-border {\n    border-top: 1px solid #ccc !important;\n    border-bottom: 1px solid #ccc !important;\n}\n\n.table-line {\n    border-bottom: 1px solid #ccc !important;\n\n    p {\n        margin-bottom: 0;\n        font-weight: 500;\n        margin-top: 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
